/**
 * Canonical route → screen-name mapping. The single source that analytics
 * super-props (AppLayout), the assistant dock, and the command palette derive
 * from — add a route once, everything follows. Screen names double as the
 * `surface` value sent with chat requests (ambient "you are on X" context).
 */
export function pathToPageName(pathname: string): string | null {
  if (pathname === '/') return 'home'
  if (pathname === '/calendar') return 'calendar'
  if (pathname === '/posts') return 'posts'
  if (pathname.startsWith('/compose/')) return 'composer'
  if (pathname === '/brand') return 'brand'
  if (pathname === '/integrations') return 'integrations'
  if (pathname === '/collaborators') return 'collaborators'
  if (pathname === '/billing') return 'billing'
  if (pathname === '/api-keys') return 'api-keys'
  if (pathname === '/profile') return 'profile'
  return null
}

/**
 * Rooms with their own resident agent keep their native chat instead of the
 * global dock — today that's only the composer (SideChat). One colleague,
 * many rooms — never two chats in the same room. Every OTHER named screen
 * (home and brand included) gets the same dock: one FAB, one window.
 */
const RESIDENT_AGENT_PAGES = new Set(['composer'])

/** The dock surface for a pathname, or undefined where a resident agent lives. */
export function dockSurfaceForPath(pathname: string): string | undefined {
  const page = pathToPageName(pathname)
  return page && !RESIDENT_AGENT_PAGES.has(page) ? page : undefined
}
